<template>
  <div class="kf-image">
    <img
      :alt="alt"
      :src="src"
      :class="{'is-rounded': rounded}"
    >
    <p
      v-if="caption"
      class="kf-image-caption"
    >
      {{ caption }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'KfImage',
  props: {
    src: {
      type: String,
      default: null,
    },
    alt: {
      type: String,
      default: '',
    },
    caption: {
      type: String,
      default: '',
    },
    rounded: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="postcss">
.kf-image {
  img {
    &.is-rounded {
      @apply rounded;
    }
  }

  &-caption {
    @apply text-sm text-gray-500 mt-2;
  }
}
</style>
